/* Spintronik Spiraltunnel, Seitenansicht. */
(function () {
  function starte(wurzel) {
    var c = wurzel.querySelector('canvas.tunnel');
    if (!c || wurzel.dataset.gestartet === 'ja') return;
    if (wurzel.dataset.tunnel === 'false') { c.style.display = 'none'; return; }
    wurzel.dataset.gestartet = 'ja';

    var ctx = c.getContext('2d');
    var reduziert = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var farbe = wurzel.dataset.akzent || '150,38,43';
    var deck = parseFloat(wurzel.dataset.deckkraft || '0.9');
    var WINDUNG = parseFloat(wurzel.dataset.windungen || '7');

    var PUNKTE = 900, RINGE = 22, TEMPO = 0.09, WARTE = 2.0, DAUER = 1.8;
    var p = [], B = 0, H = 0, x0 = 0, x1 = 0, cy = 0, R = 0, start = null, laeuft = true;

    c.style.opacity = deck;

    function aufbau() {
      var r = c.getBoundingClientRect();
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      B = r.width; H = r.height;
      if (!B || !H) return;
      c.width = B * dpr; c.height = H * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      x0 = -B * 0.08; x1 = B * 1.08;
      cy = H * 0.56;
      R = Math.min(H * 0.40, B * 0.22);
      var saat = 20260818;
      function zufall() { saat = (saat * 1664525 + 1013904223) % 4294967296; return saat / 4294967296; }
      p = [];
      for (var i = 0; i < PUNKTE; i++) {
        p.push({ u: i / (PUNKTE - 1), cx: zufall() * B, cy: zufall() * H, verz: zufall() * 0.4 });
      }
    }

    function weich(t) { return t < 0 ? 0 : t > 1 ? 1 : 1 - Math.pow(1 - t, 3); }

    function lage(u, phase) {
      var x = x0 + u * (x1 - x0);
      var w = u * WINDUNG * Math.PI * 2 + phase;
      var tiefe = Math.cos(w);
      var s = 1 + tiefe * 0.16;
      return { x: x + tiefe * R * 0.16, y: cy + Math.sin(w) * R * s, t: tiefe };
    }

    function zeichne(fort, zeit) {
      ctx.clearRect(0, 0, B, H);
      var phase = zeit * TEMPO * Math.PI * 2;
      if (fort > 0.5) {
        var a = (fort - 0.5) / 0.5;
        for (var j = 0; j < RINGE; j++) {
          var x = x0 + (j / (RINGE - 1)) * (x1 - x0);
          ctx.beginPath();
          ctx.ellipse(x, cy, R * 0.20, R, 0, 0, Math.PI * 2);
          ctx.strokeStyle = 'rgba(' + farbe + ',' + (0.13 * a).toFixed(3) + ')';
          ctx.lineWidth = 1;
          ctx.stroke();
        }
      }
      var vor = null;
      for (var i = 0; i < p.length; i++) {
        var q = p[i];
        var t = weich((fort - q.verz) / (1 - q.verz));
        var z = lage(q.u, phase);
        var px = q.cx + (z.x - q.cx) * t;
        var py = q.cy + (z.y - q.cy) * t;
        var naehe = (z.t + 1) / 2;
        if (vor) {
          var al = Math.max(0, (t - 0.45) / 0.55);
          ctx.beginPath();
          ctx.moveTo(vor.x, vor.y); ctx.lineTo(px, py);
          ctx.strokeStyle = 'rgba(' + farbe + ',' + ((0.08 + 0.42 * naehe) * al).toFixed(3) + ')';
          ctx.lineWidth = 0.7 + 1.6 * naehe;
          ctx.stroke();
        }
        vor = { x: px, y: py };
        if (i % 5 === 0) {
          ctx.beginPath();
          ctx.arc(px, py, (0.8 + 2.0 * naehe) * (0.5 + 0.5 * t), 0, Math.PI * 2);
          ctx.fillStyle = 'rgba(' + farbe + ',' + ((0.16 + 0.58 * naehe) * (0.4 + 0.6 * t)).toFixed(3) + ')';
          ctx.fill();
        }
      }
    }

    function lauf(ms) {
      if (!laeuft) return;
      if (start === null) start = ms;
      var s = (ms - start) / 1000;
      zeichne(Math.min(Math.max((s - WARTE) / DAUER, 0), 1), s);
      requestAnimationFrame(lauf);
    }

    aufbau();
    if (reduziert) { zeichne(1, 0); } else { requestAnimationFrame(lauf); }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (eintraege) {
        eintraege.forEach(function (e) {
          if (e.isIntersecting) {
            if (!laeuft && !reduziert) { laeuft = true; start = null; requestAnimationFrame(lauf); }
          } else { laeuft = false; }
        });
      }, { threshold: 0.05 }).observe(wurzel);
    }

    var timer;
    window.addEventListener('resize', function () { clearTimeout(timer); timer = setTimeout(aufbau, 180); });
  }

  function alle() { document.querySelectorAll('section[id^="hero-"]').forEach(starte); }

  document.addEventListener('DOMContentLoaded', alle);
  alle();
  document.addEventListener('shopify:section:load', function (e) {
    var w = e.target.querySelector('section[id^="hero-"]');
    if (w) { w.dataset.gestartet = ''; starte(w); }
  });
})();
